import { render, staticRenderFns } from "./DeleteJobFamilyDialog.vue?vue&type=template&id=22b25ca5"
import script from "./DeleteJobFamilyDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteJobFamilyDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports